import {useEffect, useRef} from 'react';
import {useLayoutEffect} from "./use_isomorphic_layout_effect";

/*
 useTimeout(timeout, callback) calls callback() after the given timeout expressed in milliseconds.
 Timer resets on timeout or callback change.
 If desired, caller must use useCallback to pass a stable callback.
 Callback will not be called if component unmounts before timeout fires.
*/
export const useTimeout = (timeout, callback) => {
    const ref = useRef(0);
    useEffect(() => {
        if (timeout > 0) {
            ref.current = setTimeout(callback, timeout);
        }
        return () => {
            if (ref.current !== 0) {
                clearTimeout(ref.current)
            }
        };
    }, [timeout, callback]);
};

export const useNoWindowScroll = (when) => {
    const scrollY = useRef(false);
    useLayoutEffect(() => {
        if (scrollY.current === false && when) {
            scrollY.current = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY.current}px`;
        } else if (scrollY.current !== false && !when) {
            const top = scrollY.current;
            scrollY.current = false;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, top);
        }
    }, [scrollY, when])
};
